<template>
  <section>
    <img class="logo" src="../assets/img/logo.png" alt="Mobsuccess Catalog Builder">
    <h1>{{$t('title')}}</h1>
    <form @submit.prevent="submit">
      <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card>
            <div slot="header">
              <h3>{{$t('auth.title')}}</h3>
            </div>
            <div>
              <span>{{$t('auth.subtitle')}}</span>
              <vs-row vs-justify="center">
                <vs-input
                  type="email"
                  :placeholder="$t('form.placeholders.email')"
                  v-model="email"
                />
              </vs-row>
              <vs-row vs-justify="center">
                <vs-input
                  type="password"
                  :placeholder="$t('form.placeholders.password')"
                  v-model="password"
                />
              </vs-row>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button color="primary">{{$t('auth.button')}}</vs-button>
              </vs-row>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </form>
  </section>
</template>

<script>
import Auth from '../mixins/Auth.vue'
export default {
  name: 'component-login',

  mixins: [Auth],

  data: () => ({
    email: '',
    password: ''
  }),

  methods: {
    submit() {
      this.$vs.loading({ color: 'primary' })
      this.login({
        email: this.email,
        password: this.password
      }).then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('auth.error.title'),
            text: this.$t('auth.error.text')
          })
        }

        localStorage.setItem('user-token', res.body.token)
        location.reload()
        this.$vs.loading.close()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  margin: 20px 0;
}
section {
  margin: 100px 0;
  .logo {
    max-width: 100px;
  }
}
.vs-con-input-label {
  margin: 5px 0;
}
</style>
